import { Button, Typography, useTheme } from "@mui/material";
import React from "react";
import ArrowRightSVG from "../../../media/images/icons/arrow-right";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../hooks/useRedux";

interface Props {
  goBack?: () => void;
}

export default function NavBackButton({ goBack }: Props) {
  const theme = useTheme();
  const navigate = useNavigate();

  const { themeMode } = useAppSelector((state) => state.setting);

  return (
    <Button
      onClick={() => navigate(-1)}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "3px",
        borderRadius: "8px",
        backgroundColor: theme.palette.info.dark,
        "&.MuiButtonBase-root:hover": {
          bgcolor: theme.palette.info.dark,
          // borderColor: type === "contained" ? bgColor : "",
          // border: type === "outlined" ? borderColor : "",
          // // borderWidth: "2px",
          // // borderStyle: "solid",
          // // borderColor: type === "outlined" ? borderColor : "",
          // opacity: 0.92,
        },
        "& .MuiTouchRipple-root": {
          color: `#ffffff !important`,
          //   borderWidth: "0px !important",
          //   backgroundColor: theme.palette.info.dark,
        },
        // "& .MuiButtonBase-root": {
        //   bgColor: `${theme.palette.info.dark} !important`,
        //   borderWidth: "0px !important",
        //   backgroundColor: theme.palette.info.dark,
        // },
      }}
    >
      <ArrowRightSVG
        color={
          themeMode === "light" ? theme.palette.background.default : "#fff"
        }
      />
      <Typography
        variant="body2"
        sx={{
          color: "#ffffff",
        }}
      >
        بازگشت
      </Typography>
    </Button>
  );
}
